/** Extract a human-readable message from an axios/unknown mutation error. */
export function errorMessage(err: unknown): string {
  const res = (err as { response?: { data?: { error_description?: string; error?: string; message?: string } } })
    ?.response;
  return (
    res?.data?.error_description ??
    res?.data?.error ??
    res?.data?.message ??
    (err instanceof Error ? err.message : 'Something went wrong. Please try again.')
  );
}
